module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('v-text-field', _vm._b({
    staticClass: "input-border-inset",
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": _vm.sendValue,
      "blur": _vm.sendValueOnBlur
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b612b1ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/input-text.vue
// module id = 945
// module chunks = 1 2 3 4 5 20 23 24 26